import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49ab1134")

_pushScopeId("data-v-49ab1134")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 仮登録患者様本登録 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "仮登録患者様一覧", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 仮登録患者様を削除すると、一緒に予約日も削除されます。")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("削除してもいいですか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_list_title = _resolveComponent("list-title")
  const _component_list_row = _resolveComponent("list-row")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          _createVNode(_component_vue_content, { class: "vue-content-remain-child" }, {
            default: _withId(() => [
              _hoisted_2,
              (_ctx.temporaryPatients.length===0)
                ? (_openBlock(), _createBlock("div", _hoisted_3, "仮登録の患者様はありません"))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_list_title, { titles: _ctx.titles }, null, 8, ["titles"]),
                    _createVNode(_component_vue_y_scroll_area, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                          return (_openBlock(), _createBlock(_component_list_row, {
                            key: row.id,
                            rowId: row.id,
                            columns: row.columns,
                            onClick: ($event: any) => (_ctx.onClick($event.emitType, row.id))
                          }, null, 8, ["rowId", "columns", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "deleteConfirmRef",
        onYes: _ctx.yesDelete
      }, {
        default: _withId(() => [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})